import { trackRouter } from 'vue-gtag-next'
import { getData, fetchPageBySlug } from '@streampac.io/chef_sp_1'
import { createRouter, createWebHistory } from 'vue-router'
import { useLoadingManager } from '@/stores/loadingManager'
import { useAuthenticationData } from '@/composables/useAuthenticationData'
import { useGlobalStore } from '@/stores/global'
import { useCurrentUserData } from '@/composables/useUserData'

import Home from '@/views/Home/index.vue'

const ActivateAccount = () => import('@/views/ActivateAccount/index.vue')
const Account = () => import('../views/Account/index.vue')

const LoginPage = () => import('../views/LoginPage/index.vue')

const ResetPasswordPage = () => import('../views/ResetPasswordPage/index.vue')

const NotFound = () => import('../views/NotFound/index.vue')

const RegularPage = () => import('../views/RegularPage/index.vue')

const ThemasPage = () => import('../views/ThemasPage/index.vue')

const UserTrainingSingle = () => import('../views/UserTrainingSingle/index.vue')

const HowToPage = () => import('../views/HowToPage/index.vue')

const BlogPage = () => import('../views/BlogPage/index.vue')

const FaqPage = () => import('../views/FaqPage/index.vue')

const BlogSingle = () => import('../views/BlogSingle/index.vue')

const VideoSingle = () => import('../views/VideoSingle/index.vue')

const ResultsPage = () => import('../views/ResultsPage/index.vue')

const ResultsPageFPS = () => import('../views/ResultsPageFPS/index.vue')

const ResultsPageTeam = () => import('../views/ResultsPageTeam/index.vue')

const ResultsPageCustomerGroup = () => import('../views/ResultsPageCustomerGroup/index.vue')

const ResultsPageDetail = () => import('../views/ResultsPageDetail/index.vue')

const ProgressPage = () => import('../views/ProgressPage/index.vue')

const ResultsInfoPage = () => import('../views/ResultsInfoPage/index.vue')

const routes = [
  {
    path: '/activate-account/:activateAccountId',
    name: 'ActivateAccount',
    component: ActivateAccount,
    meta: { auth: false, pageName: 'Activate account', accountSetupPage: true }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { showLoader: true, pageName: 'Home' }
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
    meta: { auth: false, pageName: 'login', accountSetupPage: true }
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: { auth: true, pageName: 'Account', forceLoader: false }
  },
  {
    path: '/reset-password/:passwordForgotId',
    name: 'ResetPasswordPage',
    component: ResetPasswordPage,
    meta: { pageName: 'Reset password', accountSetupPage: true }
  },
  //   {
  //     path: '/resultaten',
  //     name: 'ResultsPage',
  //     component: ResultsPage,
  //     meta: { pageName: 'Resultaten' }
  //   },
  {
    path: '/press-media',
    name: 'PressMedia',
    component: RegularPage,
    meta: { pageName: 'Press & Media', landingsPage: true, slug: 'press-media' }
  },
  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: RegularPage,
    meta: { pageName: 'Terms of use', landingsPage: true, slug: 'terms-of-use' }
  },
  {
    path: '/privacy-statement',
    name: 'PrivacyStatement',
    component: RegularPage,
    meta: { pageName: 'Privacy Statement', slug: 'privacy-statement', landingsPage: true }
  },
  {
    path: '/data-policy',
    name: 'DataPolicy',
    component: RegularPage,
    meta: { pageName: 'Data Policy', slug: 'data-policy', landingsPage: true }
  },
  {
    path: '/cookie-policy',
    name: 'CookiePolicy',
    component: RegularPage,
    meta: { pageName: 'Cookie Policy', slug: 'cookie-policy', landingsPage: true }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: RegularPage,
    meta: { landingsPage: true, pageName: 'Contact information', slug: 'contact'}
  },
  {
    path: '/about-fps',
    name: 'AboutFps',
    component: RegularPage,
    meta: { pageName: 'About FPS', landingsPage: true, slug: 'about-fps' }
  },
  {
    path: '/benefits',
    name: 'Benefits',
    component: RegularPage,
    meta: { pageName: 'Benefits', landingsPage: true, slug: 'benefits' }
  },
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    component: RegularPage,
    meta: { pageName: 'Subscriptions', landingsPage: true, slug: 'subscriptions' }
  },
  //Logged in routes
  {
    path: '/themes',
    name: "Themes",
    component: ThemasPage,
    meta: { auth: true, pageName: "Themes" }
  },
  {
    path: '/theme/:id',
    name: 'ThemaSingle',
    component: UserTrainingSingle,
    meta: { auth: true, pageName: 'Theme' }
  },
  {
    path: '/results',
    name: 'Results',
    component: ResultsPage,
    meta: { auth: true, pageName: 'Results', specifyPage: 'personal' }
  },
  {
    path: '/results/fps-score',
    name: 'ResultsFPS',
    component: ResultsPageFPS,
    meta: { auth: true, pageName: 'Results' }
  },
  {
    path: '/results/team',
    name: 'ResultsTeam',
    component: ResultsPage,
    meta: { auth: true, pageName: 'Results', specifyPage: 'team' }
  },
  {
    path: '/results/organisation',
    name: 'ResultsCustomerGroup',
    component: ResultsPage,
    meta: { auth: true, pageName: 'Results', specifyPage: 'organisation' }
  },
  {
    path: '/results/:id',
    name: 'ResultsDetail',
    component: ResultsPageDetail,
    meta: { auth: true, pageName: 'Results' }
  },
  {
    path: '/results/team/:id',
    name: 'ResultsDetailTeam',
    component: ResultsPageDetail,
    meta: { auth: true, pageName: 'Results', specifyPage: 'team' }
  },
  {
    path: '/results/organisation/:id',
    name: 'ResultsDetailOrganisatie',
    component: ResultsPageDetail,
    meta: { auth: true, pageName: 'Results', specifyPage: 'organisation' }
  },
  {
    path: '/results/fps-score/:id',
    name: 'ResultsDetailFPS',
    component: ResultsPageDetail,
    meta: { auth: true, pageName: 'Results', specifyPage: 'fps-score' }
  },
  {
    path: '/explanation/:id',
    name: 'Explanation',
    component: ResultsInfoPage,
    meta: { auth: true, pageName: 'Explanation', specifyPage: 'fps-score' }
  },
  {
    path: '/progress',
    name: 'Progress',
    component: ProgressPage,
    meta: { auth: true, pageName: 'Progress', restrictionUserLevel: [1] }
  },
  {
    path: '/knowledge/faqs',
    name: 'Faq',
    component: FaqPage,
    meta: { auth: true, pageName: 'Knowledge', slug: 'veelgestelde-vragen' }
  },
  {
    path: '/knowledge/articles',
    name: 'Blog',
    component: BlogPage,
    meta: { auth: true, pageName: 'Knowledge', slug: 'kennisartikelen' }
  },
  {
    path: '/knowledge/articles/:slug',
    name: 'BlogSingle',
    component: BlogSingle,
    meta: { auth: true, pageName: 'Knowledge' }
  },
  {
    path: '/knowledge/how-tos',
    name: 'Videos',
    component: HowToPage,
    meta: { auth: true, pageName: 'Knowledge', slug: 'how-to' }
  },
  {
    path: '/knowledge/how-tos/:slug',
    name: 'VideosSingle',
    component: VideoSingle,
    meta: { auth: true, pageName: 'Knowledge' }
  },
  //   {
  //     path: '/club-journey-creator',
  //     name: 'UserTrainingCreatorOverview',
  //     component: UserTrainingCreatorOverview,
  //     meta: { auth: true }
  //   },
  //   {
  //     path: '/club-journey-creator/:id',
  //     name: 'UserTrainingCreatorSingle',
  //     component: UserTrainingCreatorSingle,
  //     props: true,
  //     meta: { auth: true }
  //   },
  //   {
  //     path: '/club-journeys',
  //     name: 'UserTrainingOverview',
  //     component: UserTrainingOverview,
  //     meta: { auth: true }
  //   },
  //   {
  //     path: '/club-journeys/:id',
  //     name: 'UserTrainingSingle',
  //     component: UserTrainingSingle,
  //     props: true,
  //     meta: { auth: true }
  //   },
  //Regular page route, if no match go to 404
  {
    path: '/:slug',
    name: 'RegularPage',
    component: RegularPage,
    props: true,
    meta: {
      useUserLevelForRoute: true,
      landingsPage: true
    }
  },
  {
    path: '/404',
    name: 'content-not-found',
    component: NotFound,
    meta: { pageName: 'Page not found' }
  },
  {
    path: '/:notFound(.*)',
    name: 'not-found-404',
    component: NotFound,
    meta: { pageName: '404 not found' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }

    // Handle hash navigation
    if (to.hash) {
      // Return immediately with a small delay to ensure DOM is ready
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            el: to.hash,
            behavior: 'smooth'
          })
        }, 750) // Much shorter delay
      })
    }

    return { left: 0, top: 0 }
  }
})

// Helper function to wait for user data
const waitForUserData = async (getCurrentUser, maxWaitTime = 2000) => {
  const startTime = Date.now()

  while (!getCurrentUser.value?.level && Date.now() - startTime < maxWaitTime) {
    await new Promise((resolve) => setTimeout(resolve, 100))
  }

  return getCurrentUser.value?.level
}

router.beforeEach(async (to, from, next) => {
  const { startLoading } = useLoadingManager()
  const { data: authData } = useAuthenticationData()
  const { getCurrentUser } = useCurrentUserData()
  const globalStore = useGlobalStore()

  // 1. Check authentication requirements first
  if (to.matched.some((route) => route.meta.auth)) {
    if (getData('loginData') === null) {
      console.log('no access-token')
      return next({ path: '/' })
    }
  }

  // 2. Check user level restrictions after authentication
  if (to.matched.some((route) => route.meta.restrictionUserLevel)) {
    const allowedLevels = to.matched.find((route) => route.meta.restrictionUserLevel)?.meta
      .restrictionUserLevel

    if (authData.value.isAuthenticated) {
      const userLevel = await waitForUserData(getCurrentUser)
      //console.log('User level after wait:', userLevel, 'Allowed levels:', allowedLevels)

      if (userLevel && !allowedLevels.includes(userLevel)) {
        return next({ name: 'content-not-found' })
      }
    }
  }

  // 3. Start loading for routes that need content fetching
  if (
    to.params.slug ||
    to.matched.some((route) => route.meta.auth) ||
    to.matched.some((route) => route.meta.showLoader)
  ) {
    startLoading('Loading content...')
  }

  // 4. Handle slug-based content validation
  if (to.params.slug) {
    try {
      const content = await fetchPageBySlug(authData.value.isAuthenticated, to.params.slug)
      if (!content || Object.keys(content).length === 0) {
        return next({ name: 'content-not-found' })
      }
    } catch (error) {
      console.error('Error fetching content:', error)
      return next({ name: 'content-not-found' })
    }
  }

  // 5. Set landing page state
  const isLandingPage = to.matched.some((route) => route.meta.landingsPage)
  globalStore.setLandingsPage(isLandingPage)

  // 6. Allow navigation to proceed
  next()
})

// Add afterEach hook to stop loading
router.afterEach((to, from) => {
  const { stopLoading, forceStopLoading } = useLoadingManager()
  const globalStore = useGlobalStore()

  // If navigating from a route with forceLoader to a route without forceLoader
  // and the global loader is disabled, force stop the loader
  if (from.meta.forceLoader && !to.meta.forceLoader && !globalStore.loaderEnabled) {
    forceStopLoading()
  } else {
    stopLoading()
  }
})

trackRouter(router, { useScreenview: true })

export default router
